import { ERAS, SLIDER_MAX, SLIDER_MIN, eraForYear, eraGradient } from '../lib/eras'
import { useT } from '../i18n'
import { fmtYear } from '../lib/format'

type Props = {
  value: number
  onChange: (year: number) => void
  disabled?: boolean
}

export default function YearSlider({ value, onChange, disabled }: Props) {
  const { locale } = useT()
  const era = eraForYear(value)
  const label = locale === 'ar' ? era.label_ar : era.label_en

  return (
    <div className="space-y-3" dir="ltr">
      <div className="flex items-baseline justify-between">
        <div className="text-3xl font-bold tabular-nums font-display text-earth-900">
          {fmtYear(value, locale)}
        </div>
        <div className="text-sm text-earth-700/80" dir={locale === 'ar' ? 'rtl' : 'ltr'}>
          <span className="inline-block w-3 h-3 rounded-sm align-middle me-2" style={{ background: era.color }} />
          {label}
        </div>
      </div>

      <div className="relative touch-none">
        <div className="h-3 rounded-full" style={{ background: eraGradient() }} />
        <input
          type="range"
          min={SLIDER_MIN}
          max={SLIDER_MAX}
          step={1}
          value={value}
          onChange={(e) => onChange(parseInt(e.target.value, 10))}
          disabled={disabled}
          aria-label="Year"
          aria-valuemin={SLIDER_MIN}
          aria-valuemax={SLIDER_MAX}
          aria-valuenow={value}
          className="absolute inset-0 w-full h-12 -top-4 opacity-0 cursor-pointer disabled:cursor-not-allowed"
        />
        <div
          className="absolute -top-1.5 w-5 h-5 rounded-full bg-cream-50 border-2 border-earth-900 -translate-x-1/2 pointer-events-none shadow-md"
          style={{
            left: `${((value - SLIDER_MIN) / (SLIDER_MAX - SLIDER_MIN)) * 100}%`,
            top: '-4px',
          }}
        />
      </div>

      <div className="flex justify-between text-[10px] text-earth-700/55 tabular-nums">
        <span>{fmtYear(SLIDER_MIN, locale)}</span>
        {ERAS.slice(1, -1).map((e) => (
          <span key={e.key}>{fmtYear(e.start, locale)}</span>
        ))}
        <span>{fmtYear(SLIDER_MAX, locale)}</span>
      </div>
    </div>
  )
}
